import { produce } from 'immer'
import _ from 'lodash'
import { VirtualCardPushTaskListResponse } from 'src/models/virtualCardPushTask.models'
import {
  GET_BULK_UPLOAD_PUSH_STATUS_FAILURE,
  GET_BULK_UPLOAD_PUSH_STATUS_INIT,
  GET_BULK_UPLOAD_PUSH_STATUS_SUCCESS,
  GetBulkUploadStatusActions,
  POST_CREDIT_CARD_BULK_VIRTUAL_CARDS_SUCCESS,
  PostCreditCardBulkVirtualCardsSuccessAction,
} from 'src/redux/actions/data/virtualCardPushTasks.actions'
import { ErrorDetailMap, parseBackendErrors } from 'src/utils/error.utils'

export interface VirtualCardPushTasksState {
  listResponses: Record<string, VirtualCardPushTaskListResponse>
  multipleTopLevelError?: string
  multipleErrorDetailMap?: ErrorDetailMap<string>
}

export const initialState: VirtualCardPushTasksState = {
  listResponses: {},
}

export type Actions =
  | PostCreditCardBulkVirtualCardsSuccessAction
  | GetBulkUploadStatusActions

const VirtualCardPushTasksReducer = (
  state: VirtualCardPushTasksState = initialState,
  action: Actions,
): VirtualCardPushTasksState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case POST_CREDIT_CARD_BULK_VIRTUAL_CARDS_SUCCESS: {
        draft.listResponses = action.payload.bulkVirtualCardPush.tasks.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.taskId]: curr,
          }),
          draft.listResponses,
        )
        return draft
      }

      case GET_BULK_UPLOAD_PUSH_STATUS_INIT: {
        return draft
      }

      case GET_BULK_UPLOAD_PUSH_STATUS_SUCCESS: {
        const uploadId = action.payload.bulkVirtualCardUpload.id
        draft.listResponses = action.payload.bulkVirtualCardUpload.tasks.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.taskId]: {
              ...draft.listResponses[curr.taskId],
              taskId: curr.taskId,
              status: curr.status,
              recipient: _.get(
                draft.listResponses[curr.taskId],
                'record?.displayName',
                undefined,
              ),
              uploadId: uploadId,
              virtualCardId: curr.virtualCardId,
              errors: curr.errors,
              record: _.get(
                draft.listResponses[curr.taskId],
                'record',
                undefined,
              ),
            },
          }),
          draft.listResponses,
        )
        return draft
      }

      case GET_BULK_UPLOAD_PUSH_STATUS_FAILURE: {
        const errors = parseBackendErrors(action.payload)
        draft.multipleErrorDetailMap = errors?.errorDetailMap
        draft.multipleTopLevelError =
          errors?.errorDetailMap === undefined
            ? action.payload?.details?.[0]?.error || errors?.topLevelError
            : errors?.topLevelError
        return draft
      }
    }
  })
}

export default VirtualCardPushTasksReducer
